import { XauditModel } from '../../xaudit.model';

export class SurgicalTreatmentModel extends XauditModel {
  SurgicalTretmentID: string;
  PatientID: string;
  CaseWorkItemFormsId: string;
  CaseWorkItemToothId: string;
  MTEToothID: string;
  enumSurgeryPreOpPrognosisId: string;
  enumSurgeryPostOpPrognosisId: string;
  SurgeryDate: Date;
  CompletedDate: Date;
  CompletedBy: string;
  ToothID: string;
  isRootM: boolean = false;
  isRootD: boolean = false;
  isRootB: boolean = false;
  isRootL: boolean = false;
  isRootMB: boolean = false;
  isRootDB: boolean = false;
  isRootS: boolean = false;
  isFurca: boolean = false;
  enumSurgeryIncisionTypeId: string;
  enumSurgeryPerfMatrixId: string;
  enumSurgeryRootFractureId: string;
  isRootPerfExt: boolean = false;
  isRootPerfB: boolean = false;
  isRootPerfL: boolean = false;
  isRootPerfM: boolean = false;
  isRootPerfPost: boolean = false;
  isRootPerfInst: boolean = false;
  isRootPerfD: boolean = false;
  enumSurgerySutureId: string;
  enumSurgerySutureNumberId: string;
  enumSurgeryBrandId: string;
  isThruThru: boolean = false;
  isCryptC_TH: boolean = false;
  isCryptC_Cutrol: boolean = false;
  isCryptC_CaSO4: boolean = false;
  isCryptC_H2O2: boolean = false;
  isCryptC_Collacot: boolean = false;
  isCryptC_EPIPelets: boolean = false;
  enumSurgeryHemostasisId: string;
  enumSurgeryRetroFillingMatrixId: string;
  OtherRetroFillingMatrix: string;
  isDehiscence: boolean = false;
  isFenestration: boolean = false;
  isSinusPerf: boolean = false;
  isEntireLesionRemoved: boolean = false;
  isPathologyTaken: boolean = false;
  SentTo: string;
  ReceivedOn: Date;
  FinalDetermination: string;
  isReferredToOS: boolean = false;
  isReferredToGP: boolean = false;
  isReferredToPerio: boolean = false;
  isReferredToOther: boolean = false;
  ReferredToOSfor: string;
  ReferredToGPfor: string;
  ReferredToPerioFor: string;
  ReferredToOtherFor: string;
  enumSurgeryStructureRemovalTimeId: string;
  enumSurgerySoftTissueCheckInId: string;
} 